import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import VerifyIdentity from '../../Components/VerifyIdentity/VerifyIdentity';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [showVerification, setShowVerification] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const handleResetPassword = () => {
    // Basic email validation
    if (!email.trim()) {
      setEmailError(true);
      return;
    }
    
    // Clear any previous error
    setEmailError(false);
    // Show verification screen
    setShowVerification(true);
  };

  if (showVerification) {
    return (
      <VerifyIdentity 
        email={email}
        onVerify={() => {/* Handle verification */}}
        onResend={() => {/* Handle resend */}}
        onGoBack={() => setShowVerification(false)}
      />
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 8, display: 'flex' }}>
      {/* Left Side - Hidden on mobile */}
      <Box sx={{ 
        flex: 1, 
        pr: 8,
        display: { xs: 'none', md: 'block' }
      }}>
        <Typography variant="h3" sx={{ 
          fontWeight: 'bold', 
          mb: 4, 
          fontSize: { xs: '2rem', md: '2.5rem' },
          color: '#000000'
        }}>
          Buy, Sell Textbooks with Ease—Connecting Students for a More Affordable Education!
        </Typography>

        <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 3 }}>
          <Box sx={{ 
            color: '#6B89FF', 
            fontSize: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: 'rgba(107, 137, 255, 0.1)',
            boxShadow: '0 2px 8px rgba(107, 137, 255, 0.2)'
          }}>✓</Box>
          <Typography variant="h6" sx={{ 
            fontSize: { xs: '1.1rem', md: '1.3rem' },
            fontWeight: '500',
            color: '#2c3e50'
          }}>
            10,000+ textbooks available for exchange
          </Typography>
        </Box>

        <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 3 }}>
          <Box sx={{ 
            color: '#6B89FF', 
            fontSize: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: 'rgba(107, 137, 255, 0.1)',
            boxShadow: '0 2px 8px rgba(107, 137, 255, 0.2)'
          }}>✓</Box>
          <Typography variant="h6" sx={{ 
            fontSize: { xs: '1.1rem', md: '1.3rem' },
            fontWeight: '500',
            color: '#2c3e50'
          }}>
            Buy and sell textbooks directly with fellow students
          </Typography>
        </Box>

        <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 3 }}>
          <Box sx={{ 
            color: '#6B89FF', 
            fontSize: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: 'rgba(107, 137, 255, 0.1)',
            boxShadow: '0 2px 8px rgba(107, 137, 255, 0.2)'
          }}>✓</Box>
          <Typography variant="h6" sx={{ 
            fontSize: { xs: '1.1rem', md: '1.3rem' },
            fontWeight: '500',
            color: '#2c3e50'
          }}>
            Get the books you need for less—no middleman, no hassle
          </Typography>
        </Box>
      </Box>

      {/* Right Side - Full width on mobile */}
      <Box sx={{ 
        flex: 1,
        width: { xs: '100%', md: 'auto' }
      }}>
        <Typography variant="h4" sx={{ 
          mb: 1, 
          fontWeight: 'bold', 
          textAlign: 'center',
          color: '#000000'
        }}>
          Reset password
        </Typography>
        
        <Typography sx={{ 
          mb: 4, 
          textAlign: 'center',
          color: '#666',
          fontSize: '1.1rem'
        }}>
          Enter your Email address and we will send you instructions to reset your password.
        </Typography>

        <Box component="form" sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: 3,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          padding: 3,
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(107, 137, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(107, 137, 255, 0.1)'
        }}>
          <Box sx={{ height: '56px' }}> {/* Fixed height container */}
            <TextField
              fullWidth
              label="Email address*"
              variant="outlined"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError(false);
              }}
              error={emailError}
              helperText={emailError ? "Email is required" : " "} // Space character maintains height
              sx={{
                '& .MuiFormHelperText-root': {
                  position: 'absolute',
                  bottom: '-20px',
                }
              }}
            />
          </Box>

          <Button
            variant="contained"
            fullWidth
            sx={{
              background: 'linear-gradient(135deg, #6B89FF 0%, #5A75E6 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #5A75E6 0%, #4A65D6 100%)',
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px rgba(107, 137, 255, 0.3)'
              },
              textTransform: 'none',
              borderRadius: '30px',
              height: '56px',
              fontSize: '18px',
              fontWeight: '600',
              mb: 0,
              boxShadow: '0 4px 15px rgba(107, 137, 255, 0.2)',
              transition: 'all 0.3s ease'
            }}
            onClick={handleResetPassword}
          >
            Reset password
          </Button>

          <Link 
            to="/login" 
            style={{ 
              color: '#6B89FF', 
              textDecoration: 'none',
              textAlign: 'center'
            }}
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              Cancel
            </Typography>
          </Link>
        </Box>
      </Box>
    </Container>
  );
} 